import r from "@mui/icons-material/CloseRounded";
import { styled as t, Button as c } from "@mui/material";
import { jsx as o } from "react/jsx-runtime";
const i = t(c)`
  height: 50px;
  aspect-ratio: 1;
  padding: 5px 5px;
`, d = t(r)`
  width: 100%;
  height: 100%;

  color: #b2b2b2;
`, m = (s) => {
  const {
    className: e,
    onClick: n
  } = s;
  return /* @__PURE__ */ o(i, {
    className: e,
    onClick: n,
    children: /* @__PURE__ */ o(d, {})
  });
};
export {
  m as default
};
//# sourceMappingURL=CloseButton.js.map
